import { render, staticRenderFns } from "./MSecondaryDomainConnect.vue?vue&type=template&id=03d345c9&"
import script from "./MSecondaryDomainConnect.vue?vue&type=script&lang=ts&"
export * from "./MSecondaryDomainConnect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports